import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {throwError} from 'rxjs';

import {RoutesService} from '../Routes/routes.service';

import {HomeService} from '../../Menus/Home/home.service';

import {Login} from 'app/core-ui/abstract/login/Login';
import {MenuService} from 'app/core-ui/abstract/menu/menu.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {ModalDirective} from 'ngx-bootstrap/modal';

@Component({
  selector: 'login',
  templateUrl: 'login.component.html',
  providers: [MenuService, RoutesService, HomeService],
})
export class LogInComponent implements OnInit, AfterViewInit {
  @ViewChild('msgModal') public msgModal: ModalDirective;

  /*
   *  Modal handling
   */

  public showChildModal(): void {
    this.msgModal.show();
  }

  public hideChildModal(): void {
    this.msgModal.hide();
  }

  public loading: boolean = false;

  public loginerror = false;
  public loginmsg = '';

  public expired = false;
  public chpwd = false;
  public sso = false;

  public redirectTitle = '';
  public redirectMsg = '';

  public auth_type = '';
  public auth_rev = '';

  constructor(
    public router: Router,
    public menusService: MenuService,
    public routesService: RoutesService,
    public securityService: SecurityService,
    public logger: LogService,
    public visualsService: VisualsService,
    public configService: ConfigService,
    public homeService: HomeService,
    public eventsEmitterService: EventsEmitterService,
    public route: ActivatedRoute,
  ) {
    //this.securityService.clearStorages();
    localStorage.setItem(
      'langId',
      this.configService.getLangDefault() ? this.configService.getLangDefault().toString() : '2',
    );
  }

  ngAfterViewInit() {
    if (this.expired || this.chpwd || this.sso) {
      this.showChildModal();
    }
  }

  ngOnInit(): void {
    this.route.params.subscribe({
      next: (params) => {
        this.logger.log(params);
        if (params['expired']) {
          this.expired = true;
          this.redirectTitle = 'Logout';
          this.redirectMsg = 'You were logged out due to inactivity.';
        }
        if (params['chpwd']) {
          this.chpwd = true;
          this.redirectTitle = 'Success';
          this.redirectMsg = 'Password Changed Successfully!';
        }
        if (params['sso']) {
          this.sso = true;
          this.redirectTitle = 'Error';
          this.redirectMsg = 'Silent Login Failed, please login with username and password.';
        }
      },
    });
  }

  public goToRegister() {
    this.router.navigateByUrl('register');
  }

  public goToSso() {
    window.location.href = this.configService.getSamlUrl();
  }

  public goToForgotPass() {
    this.router.navigateByUrl('forgotPassword');
  }

  public model: Login = new Login('password', '', '');

  public doLogin(login: Login) {
    this.loading = true;
    this.loginerror = false;

    //real
    this.securityService.sendTokenRequest(login).subscribe({
      next: (data) => {
        this.logger.log(data);
        if (data) {
          this.securityService.saveToStorage('access_token', data.access_token);
          this.securityService.saveToStorage('refresh_token', data.refresh_token);
          this.securityService.getAuthorities().subscribe({
            next: (data) => {
              let roles: any[] = data;
              this.securityService.setUserRoles(roles);

              Promise.all(this.saveVisualsToStorage()).then(
                (success) => {
                  //this.loading = false;
                  this.routesService.getRoutes('menu/home');
                  this.securityService.saveToStorage('userName', login.username);
                },
                (error) => {
                  this.loading = false;
                  this.loginerror = true;
                  this.loginmsg = 'Error. Please try again.';
                },
              );
            },
            error: (error) => {
              this.loading = false;
              this.loginerror = true;
              this.loginmsg = 'Error. Please try again.';
            },
          });

          return true;
        }
      },
      error: (error) => {
        this.loading = false;
        this.loginerror = true;
        this.loginmsg = error;

        //disabled , locked, expired
        if (error.toString().indexOf('expired') > 0) {
          localStorage.setItem('changePassword', this.model.username);
          this.router.navigateByUrl('changePassword');
        }
        if (error.toString().indexOf('disabled') > 0) {
          localStorage.setItem('confirm', this.model.username);
          this.router.navigateByUrl('confirm');
        }

        this.logger.error(error);
        return throwError(() => new Error(error));
      },
    });
  }

  public saveVisualsToStorage() {
    let langs = this.configService.getLangs();
    this.logger.log(langs);

    let promises = [];

    localStorage.setItem(
      'groupServiceMap',
      JSON.stringify({
        claccModal: 'ClaccModalService',
        clientModal: 'ClientModalService',
        debtorModal: 'DebtorModalService',
        companyModal: 'CompanyModalService',
      }),
    );

    //get all menus and visuals
    //and all <select> lookup/param/currency options
    langs.forEach((element) => {
      localStorage.setItem('lkpCellRender' + element['id'], '{}');

      promises.push(this.menusService.getMenusForUser(element['id']).toPromise());

      promises.push(this.visualsService.getAllVisuals(element['id']).toPromise());

      //additional lookups go here
      promises.push(this.visualsService.getAllLookups(element['id']).toPromise());

      promises.push(this.visualsService.getCurrencies(element['id']).toPromise());
    });

    return promises;
  }
}
